import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openPlayer } from '../../../actions/media/media'
import BackButton from "../../dashboardNew/components/tools/BackButton";

class PodcastHeroComponent extends Component {

    state = ({
        isDefault: null
    })

    renderSeriesTitle() {
        const title = this.props.defaultSeries.title
        return (
            <h1 className="heading-two series">{title}</h1>
        )
    }
    renderSeriesDesc() {
        const desc = this.props.defaultSeries.description
        return (
            <p className="body-copy">{desc}</p>
        )
    }

    listenPodcast(episodes, index) {
        const {todoListUpdate, openPlayer} = this.props;
        const personId = localStorage.getItem('person_id')
        openPlayer(episodes, index)
        todoListUpdate(personId, 3)

    }

    renderEpisodeTitle() {
        const defaultName = this.props.defaultEpisode.name
        const currentName = !this.props.series.name ? null : this.props.series.name

        return (
            !currentName ?
                <h2 className="heading-main">{defaultName}</h2> : <h2 className="heading-main">{currentName}</h2>
        )
    }

    renderEpisodeDescription() {
        const defaultDescription = !this.props.defaultEpisode.longDesc ? null : this.props.defaultEpisode.longDesc;
        const currentDescription = !this.props.series.longDesc ? null : this.props.series.longDesc
        return (

            !currentDescription ?
                <p className="body-copy">{defaultDescription}</p> : <p className="body-copy">{currentDescription}</p>
        )

    }

    render() {
        const { series, episodes } = this.props

        return (
            <section className="container podcast-header">
                {series && <div className="row">
                    <div className="col-12">
                        <BackButton
                            title="Go to Podcasts"
                            path="/training/podcasts"
                        />
                        {this.renderSeriesTitle()}
                        {this.renderSeriesDesc()}
                        <div className="episode-info-hold">
                            {this.props.defaultEpisode && this.renderEpisodeTitle()}
                            {this.props.defaultEpisode && this.renderEpisodeDescription()}
                        </div>
                    </div>
                    {series.uid &&
                        <div className="col-12 button-hold">
                            <button
                                className="theme-button"
                                onClick={() => this.listenPodcast(episodes, this.props.currentIndex)}
                            >
                                Listen
                        </button>
                        </div>
                    }
                </div>}
            </section>
        )
    }
}

PodcastHeroComponent.propTypes = {
    id: PropTypes.string,
    imageURL: PropTypes.string,
    handleClick: PropTypes.func,
    header: PropTypes.string,
    description: PropTypes.string
};


const mapDispatchToProps = dispatch => {
    return {
        openPlayer: (tracks, index) => dispatch(openPlayer(tracks, index))
    };
};
export default connect(null, mapDispatchToProps)(PodcastHeroComponent);



// WEBPACK FOOTER //
// src/client/components/common/podcasts/PodcastHeroComponent.js